import { render, staticRenderFns } from "./ChangeAttendanceTable.vue?vue&type=template&id=2bccbc56"
import script from "./ChangeAttendanceTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChangeAttendanceTable.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports